import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as e } from "react/jsx-runtime";
import { createContext as t, useRef as r, useContext as n } from "react";
import { config as i, useSpring as c, animated as o } from "react-spring";
import { useDrag as u } from "@use-gesture/react";
import { u as s, a as l, b as a, c as f, d } from "./useThumbsModule-0944decf.js";
import "rxjs";
import "screenfull";
var h = t(void 0),
    g = Object.assign(Object.assign({}, i.default), {
  mass: 1,
  velocity: 0
});

function m(_ref) {
  var t = _ref.items,
      _ref$withLoop = _ref.withLoop,
      n = _ref$withLoop === void 0 ? !1 : _ref$withLoop,
      m = _ref.draggingSlideTreshold,
      _ref$springConfig = _ref.springConfig,
      v = _ref$springConfig === void 0 ? i.default : _ref$springConfig,
      _ref$shouldResizeOnWi = _ref.shouldResizeOnWindowResize,
      p = _ref$shouldResizeOnWi === void 0 ? !0 : _ref$shouldResizeOnWi,
      _ref$withThumbs = _ref.withThumbs,
      y = _ref$withThumbs === void 0 ? !1 : _ref$withThumbs,
      _ref$enableThumbsWrap = _ref.enableThumbsWrapperScroll,
      b = _ref$enableThumbsWrap === void 0 ? !0 : _ref$enableThumbsWrap,
      _ref$slideWhenThresho = _ref.slideWhenThresholdIsReached,
      x = _ref$slideWhenThresho === void 0 ? !0 : _ref$slideWhenThresho,
      _ref$carouselSlideAxi = _ref.carouselSlideAxis,
      w = _ref$carouselSlideAxi === void 0 ? "x" : _ref$carouselSlideAxi,
      _ref$thumbsSlideAxis = _ref.thumbsSlideAxis,
      T = _ref$thumbsSlideAxis === void 0 ? "x" : _ref$thumbsSlideAxis,
      O = _ref.prepareThumbsData,
      _ref$initialActiveIte = _ref.initialActiveItem,
      j = _ref$initialActiveIte === void 0 ? 0 : _ref$initialActiveIte,
      I = _ref.initialStartingPosition,
      _ref$disableGestures = _ref.disableGestures,
      S = _ref$disableGestures === void 0 ? !1 : _ref$disableGestures,
      _ref$gutter = _ref.gutter,
      E = _ref$gutter === void 0 ? 0 : _ref$gutter,
      _ref$startEndGutter = _ref.startEndGutter,
      A = _ref$startEndGutter === void 0 ? 0 : _ref$startEndGutter,
      C = _ref.touchAction,
      R = _ref.slideAmount,
      _ref$freeScroll = _ref.freeScroll,
      $ = _ref$freeScroll === void 0 ? !1 : _ref$freeScroll,
      W = _ref.enableFreeScrollDrag,
      _ref$itemsPerSlide = _ref.itemsPerSlide,
      L = _ref$itemsPerSlide === void 0 ? 1 : _ref$itemsPerSlide,
      _ref$slideType = _ref.slideType,
      M = _ref$slideType === void 0 ? "fixed" : _ref$slideType;

  var F = r(!0),
      N = r("initial"),
      P = n ? t.length === L ? [].concat(_toConsumableArray(t), _toConsumableArray(t), _toConsumableArray(t), _toConsumableArray(t), _toConsumableArray(t)) : [].concat(_toConsumableArray(t), _toConsumableArray(t), _toConsumableArray(t)) : t,
      z = r(j),
      D = r(null),
      B = r(null),
      k = r(!1),
      q = r(!1),
      G = r(!1),
      V = r(0),
      Y = r(!1),
      H = r(0),
      X = r(0),
      J = r(0),
      K = r(t),
      Q = r(null != m ? m : 0),
      U = r(L),
      Z = r(E),
      _ = r(A),
      ee = r(j),
      te = r(I),
      re = r(w);

  U.current = L, Z.current = E, _.current = A, ee.current = j, te.current = I, re.current = w;

  var _c = c(function () {
    return {
      y: 0,
      x: 0,
      onChange: function onChange(_ref2) {
        var e = _ref2.value;
        D.current && $ && (D.current["x" === re.current ? "scrollLeft" : "scrollTop"] = Math.abs(e[re.current]));
      }
    };
  }),
      _c2 = _slicedToArray(_c, 2),
      ne = _c2[0],
      ie = _c2[1];

  function ce() {
    var e = null === (t = B.current) || void 0 === t ? void 0 : t.querySelector(".use-spring-carousel-item");
    var t;
    if (!e) throw Error("No carousel items available!");
    return e.getBoundingClientRect()["x" === re.current ? "width" : "height"] + Z.current;
  }

  function oe() {
    return ne[re.current].get();
  }

  function ue() {
    return ce() * t.length < function () {
      if (!D.current) throw new Error("mainCarouselWrapperRef is not available");
      return D.current.getBoundingClientRect()["x" === re.current ? "width" : "height"];
    }();
  }

  function se() {
    var e;
    return Math.round(Number(null === (e = B.current) || void 0 === e ? void 0 : e["x" === re.current ? "scrollWidth" : "scrollHeight"]) - B.current.getBoundingClientRect()["x" === re.current ? "width" : "height"]);
  }

  function le() {
    return 0 === Ee();
  }

  function ae() {
    if (!B.current) return 0;
    var e = ce();

    if ("fluid" === M && "number" == typeof R) {
      if (R < e) throw new Error("slideAmount must be greater than the width of a single item.");
      return R;
    }

    return e;
  }

  function fe(e, r) {
    var i = "x" === re.current ? "left" : "top";

    function c() {
      return ce() * t.length;
    }

    function o(t) {
      n ? (e.style.top = "0px", e.style[i] = "-".concat(t - _.current, "px")) : (e.style.left = "0px", e.style.top = "0px", r && F.current && (e.style[i] = "calc(-".concat(r, " * 100%)")));
    }

    function u() {
      o(c());
    }

    if ("fixed" === M) {
      if (U.current > 1) switch (te.current) {
        default:
        case "start":
          u();
          break;

        case "center":
          s = U.current, o(c() - ae() * Math.round((s - 1) / 2));
          break;

        case "end":
          !function (e) {
            o(c() - ae() * Math.round(e - 1));
          }(U.current);
      } else u();
    } else u();

    var s;
  }

  function de() {
    if (H.current = window.innerWidth, "fluid" === M) {
      if (ue()) return void ie.start(_defineProperty({
        immediate: !0
      }, re.current, 0));

      if (V.current = se(), Y.current) {
        var _e = -V.current;

        ie.start(_defineProperty({
          immediate: !0
        }, re.current, _e));
      }

      X.current = window.innerWidth;
    } else ie.start(_defineProperty({
      immediate: !0
    }, re.current, -ae() * Ee()));

    V.current = se(), fe(B.current);
  }

  function he() {
    window.innerWidth === H.current || $ || de();
  }

  s(function () {
    Q.current = m || Math.floor(ae() / 2 / 2), de();
  }, [m, L, E, A, j, I, w, T]);

  var _l = l(),
      ge = _l.useListenToCustomEvent,
      me = _l.emitObservable,
      _a = a({
    mainCarouselWrapperRef: D,
    emitObservable: me,
    handleResize: he
  }),
      ve = _a.enterFullscreen,
      pe = _a.exitFullscreen,
      ye = _a.getIsFullscreen,
      _f = f({
    withThumbs: y,
    items: t,
    thumbsSlideAxis: T,
    springConfig: v,
    prepareThumbsData: O,
    slideType: M,
    getFluidWrapperScrollValue: se,
    getSlideValue: ae
  }),
      be = _f.thumbsFragment,
      xe = _f.handleThumbsScroll;

  function we() {
    if (!D.current) throw new Error("Missing mainCarouselWrapperRef.current");
    return D.current["x" === re.current ? "scrollLeft" : "scrollTop"];
  }

  function Te() {
    return "boolean" == typeof W ? W : "function" == typeof W && W();
  }

  var Oe = u(function (e) {
    var t = e.dragging,
        r = e.offset["x" === re.current ? 0 : 1],
        i = e.movement["x" === re.current ? 0 : 1],
        c = i > Q.current,
        o = i < -Q.current,
        u = e.direction["x" === re.current ? 0 : 1];

    function s() {
      e.cancel();
    }

    function l() {
      je(u > 0 ? "prev" : "next");
    }

    function a() {
      me(Object.assign({
        eventName: "onDrag",
        slideActionType: Ie()
      }, e));
    }

    function f() {
      var _ie$start4, _ie$start5, _ie$start6, _ie$start7;

      "fluid" === M ? ue() || le() && "prev" === Ie() ? ie.start((_ie$start4 = {}, _defineProperty(_ie$start4, re.current, 0), _defineProperty(_ie$start4, "config", Object.assign({
        velocity: e.velocity
      }, v)), _ie$start4)) : Y.current && "next" === Ie() ? ie.start((_ie$start5 = {}, _defineProperty(_ie$start5, re.current, -V.current), _defineProperty(_ie$start5, "config", Object.assign({
        velocity: e.velocity
      }, v)), _ie$start5)) : ie.start((_ie$start6 = {}, _defineProperty(_ie$start6, re.current, J.current), _defineProperty(_ie$start6, "config", Object.assign({
        velocity: e.velocity
      }, v)), _ie$start6)) : ie.start((_ie$start7 = {}, _defineProperty(_ie$start7, re.current, -Ee() * ae()), _defineProperty(_ie$start7, "config", Object.assign({
        velocity: e.velocity
      }, v)), _ie$start7));
    }

    function d() {
      Math.abs(oe()) + 100 >= V.current && "next" === Ie() && (Y.current = !0), "prev" === Ie() && (Y.current = !1);
    }

    if ($ && Te()) return t && (Re() || Ce(!0), l(), a(), d()), ie.start({
      from: _defineProperty({}, re.current, we()),
      to: _defineProperty({}, re.current, -r),
      config: {
        velocity: e.velocity,
        friction: 50,
        tension: 1400
      }
    }), 0 === we() && "prev" === Ie() ? void s() : void (e.last && ("prev" === Ie() ? Pe(e.velocity) : ze(e.velocity), Ce(!1)));

    if (t) {
      var _ie$start8;

      if (Re() || Ce(!0), a(), l(), d(), $) {
        if (Te()) {
          if (0 === we() && "prev" === Ie()) return void s();
          ie.start({
            config: {
              velocity: e.velocity,
              friction: 50,
              tension: 1400
            },
            from: _defineProperty({}, re.current, we()),
            to: _defineProperty({}, re.current, -r)
          });
        }

        return;
      }

      if (ie.start((_ie$start8 = {}, _defineProperty(_ie$start8, re.current, r), _defineProperty(_ie$start8, "config", {
        velocity: e.velocity,
        friction: 50,
        tension: 1e3
      }), _ie$start8)), (c || o) && ue() && "fluid" === M) s(), f();else if (Y.current && "next" === Ie() && o) Y.current = !1, s(), ie.start(_defineProperty({}, re.current, -V.current));else if (x) {
        if (o) return s(), void (!n && Ne() ? f() : ze(e.velocity));
        if (c) return s(), void (!n && le() ? f() : Pe(e.velocity));
      }
    }

    if (e.last && !x && (o || c) && !$) return Ce(!1), void (o ? !n && Ne() ? f() : ze(e.velocity) : c && (!n && le() ? f() : Pe(e.velocity)));
    !e.last || o || c || $ || (f(), me(Object.assign({
      eventName: "onDrag",
      slideActionType: Ie()
    }, e)));
  }, {
    enabled: !S,
    axis: re.current,
    from: function from() {
      return $ ? "x" === re.current ? [-we(), 0] : [0, -we()] : [ne.x.get(), ne.y.get()];
    }
  });

  function je(e) {
    N.current = e;
  }

  function Ie() {
    return N.current;
  }

  function Se(e) {
    z.current = e;
  }

  function Ee() {
    return z.current;
  }

  function Ae(e) {
    q.current = e;
  }

  function Ce(e) {
    k.current = e;
  }

  function Re() {
    return k.current;
  }

  function $e() {
    var e = Ee();
    return 0 === e ? t.length - 1 : e - 1;
  }

  function We() {
    var e = Ee();
    return e === t.length - 1 ? 0 : e + 1;
  }

  function Le(e) {
    return t.findIndex(function (t) {
      return t.id === e;
    });
  }

  function Me(e, t) {
    if ("number" == typeof e) return _defineProperty({}, re.current, e);
    if ("number" != typeof t) throw new Error("to values is not a number!");
    return _defineProperty({}, re.current, -ae() * t);
  }

  function Fe(_ref5) {
    var e = _ref5.from,
        _ref5$to = _ref5.to,
        r = _ref5$to === void 0 ? -1 : _ref5$to,
        n = _ref5.customTo,
        _ref5$immediate = _ref5.immediate,
        i = _ref5$immediate === void 0 ? !1 : _ref5$immediate,
        _ref5$onRest = _ref5.onRest,
        c = _ref5$onRest === void 0 ? function () {} : _ref5$onRest,
        o = _ref5.velocity;
    i || (Se(r), Ae(!0), me({
      eventName: "onSlideStartChange",
      slideActionType: Ie(),
      nextItem: {
        index: "fluid" === M ? -1 : r,
        id: "fluid" === M ? "" : t[r].id
      }
    })), J.current = Me(n, r)[w], ie.start(Object.assign(Object.assign(Object.assign(Object.assign({}, function (e) {
      return "number" == typeof e ? {
        from: _defineProperty({}, re.current, e)
      } : {};
    }(e)), {
      to: Me(n, r)
    }), o ? {
      config: Object.assign(Object.assign({}, g), {
        velocity: o,
        friction: void 0,
        tension: void 0
      })
    } : {
      config: Object.assign({
        velocity: 0
      }, v)
    }), {
      immediate: i,
      onRest: function onRest(e) {
        e.finished && (Ce(!1), Ae(!1), c(), i || me({
          eventName: "onSlideChange",
          slideActionType: Ie(),
          currentItem: {
            index: "fluid" === M ? -1 : Ee(),
            id: "fluid" === M ? "" : t[Ee()].id
          }
        }));
      }
    })), b && y && !i && xe(r, Ie());
  }

  function Ne() {
    return Ee() === t.length - 1;
  }

  function Pe(e) {
    if (je("prev"), Y.current = !1, "fluid" === M) {
      if (Y.current = !1, ue()) return;

      var _r = oe() + ae() + 200;

      if ($) {
        var _t = D.current.scrollLeft - ae();

        Fe({
          customTo: _t < 0 ? 0 : _t,
          from: D.current.scrollLeft,
          velocity: e
        });
      } else Fe(_r >= 0 ? n ? {
        from: oe() - ce() * t.length,
        velocity: e,
        customTo: oe() - ce() * t.length + ae()
      } : {
        customTo: 0,
        velocity: e
      } : {
        customTo: oe() + ae(),
        velocity: e
      });
    } else {
      if (!n && 0 === Ee() || G.current) return;
      le() ? Fe({
        from: oe() - ae() * t.length,
        to: t.length - 1,
        velocity: e
      }) : Fe({
        to: $e(),
        velocity: e
      });
    }
  }

  function ze(e) {
    if (je("next"), "fluid" === M) {
      if (ue()) return;

      var _r2 = Math.abs(oe() - ae()) + 100 >= V.current;

      if ($) {
        var _t2 = D.current.scrollLeft + ae() > V.current,
            _r3 = D.current.scrollLeft + ae();

        Fe({
          velocity: e,
          customTo: _t2 ? V.current : _r3,
          from: D.current.scrollLeft
        });
      } else if (n && Math.abs(oe() - ae()) >= t.length * ce()) {
        var _r4 = ce() * t.length;

        Fe({
          from: oe() + _r4,
          customTo: oe() + _r4 - ae(),
          velocity: e
        });
      } else {
        if (Y.current) return;
        _r2 ? (Y.current = !0, Fe({
          customTo: -V.current,
          velocity: e
        })) : Fe({
          customTo: oe() - ae(),
          velocity: e
        });
      }
    } else {
      if (!n && Ee() === P.length - 1 || G.current) return;
      Math.abs(oe() - ae() + 25) > V.current && !Re() ? Y.current = !0 : Y.current ? Fe({
        to: t.length - U.current,
        velocity: e
      }) : Ne() ? Fe({
        from: oe() + ae() * t.length,
        to: 0,
        velocity: e
      }) : Fe({
        to: We(),
        velocity: e
      });
    }
  }

  function De(e) {
    var r = 0;
    if (r = "string" == typeof e ? t.findIndex(function (t) {
      return t.id === e;
    }) : e, r >= t.length) throw Error("The item you want to slide to doesn't exist. This could be due to the fact that \n        you provide a wrong id or a higher numeric index.");
    if (r === Ee() || t.length !== K.current.length && Ee() < t.length) return;
    var n = Le(K.current[Ee()].id);
    je(Le(t[r].id) > n ? "next" : "prev"), Fe({
      to: r
    });
  }

  d(function () {
    if (L % 2 == 0 && te.current) throw new Error("initialStartingPosition can be only used if itemsPerSlide is an even value.");
    if (Q.current < 0) throw new Error("draggingSlideTreshold must be greater than 0");
    if (Q.current > ae() / 2) throw new Error("draggingSlideTreshold must be equal or less than the half of the width of an item, which is ".concat(Math.floor(ae() / 2)));
    if (U.current < 1) throw new Error("The itemsPerSlide prop can't be less than 1.");
    if (U.current > t.length) throw new Error("The itemsPerSlide prop can't be greater than the total length of the items you provide.");
    if (ee.current < 0) throw new Error("The initialActiveItem cannot be less than 0.");
    if (ee.current > t.length) throw new Error("The initialActiveItem cannot be greater than the total length of the items you provide.");
    p || console.warn("You set shouldResizeOnWindowResize={false}; be aware that the carousel could behave in a strange way if you also use the fullscreen functionality or if you change the mobile orientation.");
  }), d(function () {
    function e() {
      document.hidden ? G.current = !0 : G.current = !1;
    }

    return document.addEventListener("visibilitychange", e), function () {
      document.removeEventListener("visibilitychange", e);
    };
  }), d(function () {
    F.current = !1, V.current = se(), X.current = window.innerWidth, H.current = window.innerWidth, j > 0 && (Fe({
      to: j,
      immediate: !0
    }), Se(j), !n && B.current && (B.current.style.top = "0px", B.current.style.left = "0px"));
  }), s(function () {
    j < t.length && j !== z.current && (Fe({
      to: j,
      immediate: !0
    }), Se(j));
  }, [j]), s(function () {
    if (p) return window.addEventListener("resize", he), function () {
      window.removeEventListener("resize", he);
    };
  }, [p]), s(function () {
    B.current && ("x" === re.current && (B.current.style.top = "0px"), "y" === re.current && (B.current.style.left = "0px"));
  }, [w]), s(function () {
    V.current = se();
    !(t.length === K.current.length) && t.length < K.current.length && De(t.length - 1), K.current = t;
  }, [se, t]);
  var Be = Object.assign({
    useListenToCustomEvent: ge,
    getIsFullscreen: ye,
    enterFullscreen: ve,
    exitFullscreen: pe,
    getIsAnimating: function getIsAnimating() {
      return q.current;
    },
    getIsDragging: Re,
    getIsNextItem: function getIsNextItem(e) {
      var r = Le(e),
          i = Ee();
      return n && i === t.length - 1 ? 0 === r : r === i + 1;
    },
    getIsPrevItem: function getIsPrevItem(e) {
      var r = Le(e),
          i = Ee();
      return n && 0 === i ? r === t.length - 1 : r === i - 1;
    },
    slideToPrevItem: function slideToPrevItem() {
      Pe();
    },
    slideToNextItem: function slideToNextItem() {
      ze();
    }
  }, "fixed" === M ? {
    slideToItem: De,
    getIsActiveItem: function getIsActiveItem(e) {
      return Le(e) === Ee();
    },
    getCurrentActiveItem: function getCurrentActiveItem() {
      return {
        id: t[Ee()].id,
        index: Ee()
      };
    }
  } : {});
  var ke = e(h.Provider, Object.assign({
    value: Be
  }, {
    children: e("div", Object.assign({
      ref: D,
      className: "use-spring-carousel-main-wrapper",
      "data-testid": "use-spring-carousel-wrapper"
    }, $ ? {
      onWheel: function onWheel() {
        ne[re.current].stop();
      }
    } : {}, {
      style: Object.assign({
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100%"
      }, $ ? "x" === re.current ? {
        overflowX: "auto"
      } : {
        overflowY: "auto"
      } : {})
    }, {
      children: e(o.div, Object.assign({}, Oe(), {
        className: "use-spring-carousel-track-wrapper",
        "data-testid": "use-spring-carousel-animated-wrapper",
        ref: function ref(e) {
          e && (B.current = e, fe(e, ee.current));
        },
        style: Object.assign(Object.assign(Object.assign({
          display: "flex",
          position: "relative",
          touchAction: S ? "unset" : C || ("x" === re.current ? "pan-y" : "pan-x"),
          flexDirection: "x" === re.current ? "row" : "column"
        }, function () {
          var e = "calc(100% - ".concat(2 * _.current, "px)");
          return {
            width: "x" === re.current ? e : "100%",
            height: "y" === re.current ? e : "100%"
          };
        }()), function () {
          var e = t.length / L * 100,
              r = 100 / L,
              n = "x" === re.current ? "left" : "y",
              i = Math.floor(50 / r);

          if ("fixed" === M) {
            if ("center" === te.current) return _defineProperty({}, n, "calc(-".concat(e, "% + ").concat(r * i, "%)"));
            if ("end" === te.current) return _defineProperty({}, n, "calc(-".concat(e, "% + ").concat(r * (2 * i), "%)"));
          }

          return _defineProperty({}, n, "0px");
        }()), $ ? {} : ne)
      }, {
        children: P.map(function (_ref9, n) {
          var t = _ref9.id,
              r = _ref9.renderItem;
          return e("div", Object.assign({
            className: "use-spring-carousel-item",
            "data-testid": "use-spring-carousel-item-wrapper",
            style: Object.assign({
              display: "flex",
              position: "relative"
            }, (i = U.current, "fixed" === M ? Object.assign(Object.assign({}, "x" === re.current ? {
              marginRight: "".concat(Z.current, "px")
            } : {
              marginBottom: "".concat(Z.current, "px")
            }), {
              flex: "1 0 calc(100% / ".concat(i, " - ").concat(Z.current * (i - 1) / i, "px)")
            }) : Object.assign({}, "x" === re.current ? {
              marginRight: "".concat(Z.current, "px")
            } : {
              marginBottom: "".concat(Z.current, "px")
            })))
          }, {
            children: r
          }), "".concat(t, "-").concat(n));
          var i;
        })
      }))
    }))
  })),
      qe = e(h.Provider, Object.assign({
    value: Be
  }, {
    children: be
  }));
  return Object.assign(Object.assign({}, Be), {
    carouselFragment: ke,
    thumbsFragment: qe
  });
}

function v() {
  var e = n(h);
  if (!e) throw new Error("useSpringCarouselContext must be used only inside a component that is rendered inside the Carousel.");
  return e;
}

export { m as useSpringCarousel, v as useSpringCarouselContext };